import React, { Fragment, useEffect, useState } from 'react'
import Slider from 'react-slick'
import type { Settings as ReactSlickSettings } from 'react-slick'
//import { useDataLayerAction } from '@corratech/tag-manager'
import cn from 'classnames'
import s from './Recentviewed.module.scss'

const RECENTLY_VIEWED_STORAGE_KEY = 'recentlyViewed'

const settings = {
    arrows: false,
    speed: 400,
    slidesToScroll: 1,
    slidesToShow: 5,
    draggable: true,
    infinite: false,
    dots: false,
    fade: false,
    prevArrow: <button type="button" className="slick-prev" />,
    nextArrow: <button type="button" className="slick-next" />,
    responsive: [
        {
            breakpoint: 1023,
            settings: {
                slidesToShow: 3
            }
        },
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                dots: true
            }
        }
    ]
} as ReactSlickSettings

export enum RecentlyViewedOrderEnum {
    RECENT = 'recent',
    OLD = 'old'
}

export interface RecentlyViewedProps<ProductType> {
    className?: string
    ProductTile: React.ElementType
    product?: ProductType
    maximumStorage?: number
    imgPreviewSize?: {
        imageLg: number
        imageSm: number
    }
    sliderSettings?: ReactSlickSettings
    order?: RecentlyViewedOrderEnum
}

export const RecentlyViewed = ({
    className,
    ProductTile,
    product,
    maximumStorage = 10,
    imgPreviewSize = { imageLg: 854, imageSm: 405 },
    sliderSettings = settings,
    order = RecentlyViewedOrderEnum.RECENT
}: RecentlyViewedProps<any>): JSX.Element | null => {
    const { imageLg, imageSm } = imgPreviewSize
    // Only render this on client side
    // TODO: Add fallback

    //const [t] = useTranslation()
    const t = (s: string) => s

    const getPreviewSize = (index: number) => {
        const preIndex = index + 1
        const postIndex = preIndex
        return `?auto=webp&format=pjpg&crop=1:1&width=${
            postIndex % 4 === 0 && postIndex % 12 !== 8 ? imageLg : imageSm
        }`
    }
    //const dataLayerAction = useDataLayerAction()

    const [recentProducts, setRecentProducts] = useState([])

    const recentlyViewed = JSON.parse(
        (typeof window !== 'undefined' &&
            window.localStorage.getItem(RECENTLY_VIEWED_STORAGE_KEY)) ||
            '[]'
    )

    useEffect(() => {
        if (product) {
            const getIndex = recentlyViewed.findIndex(function (element: any) {
                return element.sku === product.sku
            })

            if (getIndex === -1) {
                if (recentlyViewed.length >= maximumStorage)
                    recentlyViewed.shift()
                recentlyViewed.push(product)
                window.localStorage.setItem(
                    RECENTLY_VIEWED_STORAGE_KEY,
                    JSON.stringify(recentlyViewed)
                )
            }
            const recentProducts = recentlyViewed.filter(function (
                element: any
            ) {
                return element.sku !== product.sku
            })
            if (
                recentProducts?.length &&
                order === RecentlyViewedOrderEnum.RECENT
            ) {
                recentProducts.reverse()
            }
            setRecentProducts(recentProducts)

            /*if (recentProducts.length > 0)
          dataLayerAction({
              type: 'PLP_PAGE',
              data: {
                  type: 'recentlyViewedImpressions',
                  items: recentProducts,
                  currencyCode: storeConfig.base_currency_code,
                  list: 'Recently Viewed'
              }
          })
          */
        }
    }, [product])

    // if (window && typeof window === 'undefined') return null

    return (
        <div>
            {recentProducts && recentProducts.length > 0 && (
                <div className={cn(s['recently-viewed-products'], className)}>
                    <div
                        className={cn(
                            s['heading-container'],
                            'recently-viewed-heading-container'
                        )}
                    >
                        <h2 className={cn(s['title'], 'recently-viewed-title')}>
                            {t('Recently Viewed')}
                        </h2>
                    </div>
                    <div
                        className={cn(
                            s['products-list'],
                            'recently-viewed-products-list'
                        )}
                    >
                        <Slider {...sliderSettings}>
                            {recentProducts.map(
                                (products: any, index: number) => {
                                    return (
                                        <div
                                            className={cn(
                                                s['product-item'],
                                                'recently-viewed-product-item'
                                            )}
                                            key={index}
                                        >
                                            <ProductTile
                                                product={products}
                                                imageParam={{
                                                    width: getPreviewSize(index)
                                                }}
                                            />
                                        </div>
                                    )
                                }
                            )}
                        </Slider>
                    </div>
                </div>
            )}
        </div>
    )
}
